import request from '@/utils/request'

//

export function supplierList(params) {
  return request({
    url: '/supplier/page',
    method: 'get',

    params
  })
}
//
export function supplierBrandList(params) {
  return request({
    url: '/supplierBrand/page',
    method: 'get',

    params
  })
}

//
export function brandList(params) {
  return request({
    url: '/mrp/brand/page',
    method: 'get',

    params
  })
}
export function inventoryQuantitySecondTagList(params) {
  return request({
    url: '/inventory/physical/inventoryQuantity/senondTagList',
    method: 'get',

    params
  })
}
export function getWarehouseDropList(params) {
  return request({
    url: '/inventory/frozen/getWarehouseDropList',
    method: 'get',

    params
  })
}
export function inventoryQuantityPage(params) {
  return request({
    url: '/inventory/physical/inventoryQuantity/page',
    method: 'get',

    params
  })
}
//
export function supplierBrandDelete(params) {
  return request({
    url: '/supplierBrand/delete',
    method: 'get',

    params
  })
}
export function supplierDelete(params) {
  return request({
    url: '/supplier/delete',
    method: 'get',

    params
  })
}
export function brandDelete(params) {
  return request({
    url: '/mrp/brand/delete',
    method: 'get',

    params
  })
}

export function engineeringDelete(params) {
  return request({
    url: '/engineering/delete',
    method: 'get',

    params
  })
}

export function engineeringList(params) {
  return request({
    url: '/engineering/page',
    method: 'get',

    params
  })
}
export function getFinanceWarehouseDropList(params) {
  return request({
    url: '/inventory/frozen/getFinanceWarehouseDropList',
    method: 'get',

    params
  })
}
export function getPhysicalWarehouseDropList(params) {
  return request({
    url: '/inventory/frozen/getPhysicalWarehouseDropList',
    method: 'get',

    params
  })
}
export function getWarehousePositionDropList(params) {
  return request({
    url: '/inventory/warehouse/position/getDropList',
    method: 'get',
    params
  })
}

export function getSupplierDropList(params) {
  return request({
    url: '/inventory/frozen/getSupplierDropList',
    method: 'get',

    params
  })
}
export function getBrandDropList(params) {
  return request({
    url: '/inventory/frozen/getBrandDropList',
    method: 'get',

    params
  })
}
export function frozenList(params) {
  return request({
    url: '/inventory/frozen/page',
    method: 'get',

    params
  })
}
export function frozenDelete(params) {
  return request({
    url: '/inventory/frozen/delete',
    method: 'get',

    params
  })
}
export function getDropList(params) {
  return request({
    url: '/inventory/warehouse/getDropList',
    method: 'get',

    params
  })
}
export function getBatchNoDropList(params) {
  return request({
    url: '/purchase/aftersales/out/getBatchNoDropList',
    method: 'get',
    params
  })
}
export function inventorySnList(params) {
  return request({
    url: '/inventory/physical/inventorySn/page',
    method: 'get',

    params
  })
}
export function engineeringFind(params) {
  return request({
    url: '/engineering/find',
    method: 'get',

    params
  })
}
export function getDropListposition(params) {
  return request({
    url: '/inventory/warehouse/position/getDropList',
    method: 'get',

    params
  })
}
export function financialInventoryQuantity(params) {
  return request({
    url: '/financialInventoryQuantity/page',
    method: 'get',

    params
  })
}

//

export function supplierSave(params) {
  return request({
    url: '/supplier/save',
    method: 'post',

    data: params
  })
}

export function frozenSave(params) {
  return request({
    url: '/inventory/frozen/save',
    method: 'post',

    data: params
  })
}
export function frozenUpdate(params) {
  return request({
    url: '/inventory/frozen/update',
    method: 'post',

    data: params
  })
}

export function engineeringSave(params) {
  return request({
    url: '/engineering/save',
    method: 'post',

    data: params
  })
}
export function engineeringUpdate(params) {
  return request({
    url: '/engineering/update',
    method: 'post',

    data: params
  })
}

export function brandSave(params) {
  return request({
    url: '/mrp/brand/save',
    method: 'post',

    data: params
  })
}

export function brandUpdate(params) {
  return request({
    url: '/mrp/brand/update',
    method: 'post',

    data: params
  })
}
//
export function supplierBrandSave(params) {
  return request({
    url: '/supplierBrand/save',
    method: 'post',

    data: params
  })
}
//
export function supplierUpdate(params) {
  return request({
    url: '/supplier/update',
    method: 'post',

    data: params
  })
}
export function accountingAccount(params) {
  return request({
    url: '/financialInventory/accounting/account',
    method: 'post',

    data: params
  })
}

export function accountingPage(params) {
  return request({
    url: '/financialInventory/accounting/page',
    method: 'get',

    params
  })
}
export function backAccount(params) {
  return request({
    url: '/financialInventory/accounting/backAccount',
    method: 'get',

    params
  })
}
export function period(params) {
  return request({
    url: '/accounting/accounts/period/getCurrentPeriod',
    method: 'get',

    params
  })
}
export function getPeriodYear(params) {
  return request({
    url: '/accounting/accounts/period/getPeriodYear',
    method: 'get',

    params
  })
}
export function getPeriodNum(params) {
  return request({
    url: '/accounting/accounts/period/getPeriodNum',
    method: 'get',

    params
  })
}

export function columnConfigSave(params) {
  return request({
    url: '/columnConfig/save',
    method: 'post',

    data: params
  })
}

export function getColumnConfig(params) {
  return request({
    url: '/columnConfig/get',
    method: 'get',

    params
  })
}

export function getPeriodDetail(params) {
  return request({
    url: '/accounting/accounts/period/getPeriodDetail',
    method: 'get',

    params
  })
}
export function checkOrderStatus(params) {
  return request({
    url: '/accounting/accounts/period/checkOrderStatus',
    method: 'get',

    params
  })
}
export function returnCheckout(data) {
  return request({
    url: '/accounting/accounts/period/returnCheckout',
    method: 'post',

    data
  })
}
export function returnCheck(data) {
  return request({
    url: '/financialInventory/accounting/check',
    method: 'post',

    data
  })
}
export function returnClose(data) {
  return request({
    url: '/accounting/accounts/period/returnClose',
    method: 'post',

    data
  })
}
export function periodClose(data) {
  return request({
    url: '/accounting/accounts/period/close',
    method: 'post',

    data
  })
}
export function periodCheckout(data) {
  return request({
    url: '/accounting/accounts/period/checkout',
    method: 'post',

    data
  })
}
export function supplierCategoryAdd(data) {
  return request({
    url: '/supplierCategory/add',
    method: 'post',

    data
  })
}
export function supplierCategoryEdit(data) {
  return request({
    url: '/supplierCategory/edit',
    method: 'post',

    data
  })
}
export function treeList(params) {
  return request({
    url: '/supplierCategory/treeList',
    method: 'get',

    params
  })
}
export function materialCategoryPage(params) {
  return request({
    url: '/supplier/materialCategoryPage',
    method: 'get',

    params
  })
}
export function brandMaterialCategoryPage(params) {
  return request({
    url: '/mrp/brand/materialCategoryPage',
    method: 'get',

    params
  })
}
export function supplierCategoryDelete(params) {
  return request({
    url: '/supplierCategory/delete',
    method: 'get',

    params
  })
}
export function supplierCategoryListRoot(params) {
  return request({
    url: '/supplierCategory/listRoot',
    method: 'get',

    params
  })
}
export function isWg(params) {
  return request({
    url: '/companyAndDepart/isWg',
    method: 'get',

    params
  })
}
export function daybookList(params) {
  return request({
    url: '/report/financial/daybook/list',
    method: 'get',

    params
  })
}
export function physicalDaybookList(params) {
  return request({
    url: '/report/physical/daybook/list',
    method: 'get',

    params
  })
}
export function customerList(params) {
  return request({
    url: '/customer/page',
    method: 'get',

    params
  })
}
export function customerDelete(params) {
  return request({
    url: '/customer/delete',
    method: 'get',

    params
  })
}
export function customerSave(data) {
  return request({
    url: '/customer/save',
    method: 'post',

    data
  })
}
export function customerUpdate(data) {
  return request({
    url: '/customer/update',
    method: 'post',

    data
  })
}
